import React, { useState } from 'react'
import { redirectTo } from 'src/utils/Http';
import * as Urls from 'src/constants/EndpointUrls';
import _ from 'lodash'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { useTranslation } from 'react-i18next'

import { useTutorialContext } from '../TutorialProvider';


function Step1Modal({ cookie }) {
  const [onOpenModal, setOnOpenModal] = useState(true)
  const { setTutorialStep1 } = useTutorialContext()
  const setOnCloseModal = () => {
    setTutorialStep1({ run: false, stepIndex: 0, tourCompleted: false, type: 'show' });
    setOnOpenModal(false)
  }

  const { t } = useTranslation()
  const { run, type, stepIndex } = cookie

  const onConfirm = () => {
    if (cookie && run) {
      if (run && type == 'edit') {
        if (stepIndex >= 1) {
          redirectTo(Urls.CLIENT_EDIT)
        }
      }
      else if (run && type == 'show') {
        redirectTo(Urls.CLIENT_SHOW)
      }
    }
  }

  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.GuideTour.Modal.Title')}</CommonModal.Header>
      <CommonModal.Body>{t('features.GuideTour.Modal.ContinueWorkingTutorial')} </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={setOnCloseModal}>{t('features.GuideTour.Button.close')}</Button>
          <Button primary onClick={onConfirm}>{t('features.GuideTour.Button.next')}</Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  )
}

export default (Step1Modal)